export default "__VITE_ASSET__DDIW3ShV__"